/**
 * PostHog Analytics Provider
 * Initializes PostHog on mount and cleans up on unmount.
 * Route tracking is handled by PostHogRouteTracker in __root.tsx.
 */

import { useEffect, type ReactNode } from 'react'
import { initPostHog, shutdownPostHog } from '@/lib/posthog'
import { captureAppReloadTelemetry } from '@/lib/capacitor-updater'

interface PostHogProviderProps {
  children: ReactNode
}

export function PostHogProvider({ children }: PostHogProviderProps) {
  useEffect(() => {
    initPostHog()
    void captureAppReloadTelemetry()

    return () => {
      shutdownPostHog()
    }
  }, [])

  return <>{children}</>
}
